var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c(
        "c-card",
        { staticClass: "cardClassDetailForm", attrs: { title: "상세정보" } },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  !_vm.isApprContent
                    ? _c("c-appr-btn", {
                        ref: "appr-btn",
                        attrs: {
                          editable: _vm.editable,
                          approvalInfo: _vm.approvalInfo,
                        },
                        on: {
                          beforeApprAction: _vm.approvalRiskAssess,
                          callbackApprAction: _vm.approvalRiskAssessCallback,
                          requestAfterAction: _vm.getDetail,
                        },
                      })
                    : _vm._e(),
                  !_vm.isApprContent &&
                  _vm.editable &&
                  _vm.isOld &&
                  _vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          label: "결재취소",
                          icon: "undo",
                          color: "grey-8",
                        },
                        on: { btnClicked: _vm.cancelApproval },
                      })
                    : _vm._e(),
                  !_vm.isApprContent && _vm.btnEditable && !_vm.isOld
                    ? _c("c-btn", {
                        attrs: {
                          label: "지난 위험성평가 가져오기",
                          icon: "system_update_alt",
                        },
                        on: { btnClicked: _vm.loadAssessPlan },
                      })
                    : _vm._e(),
                  !_vm.isApprContent &&
                  _vm.isOld &&
                  _vm.disabled &&
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: {
                          label: "그래프",
                          icon: "pie_chart",
                          color: "grey-8",
                        },
                        on: { btnClicked: _vm.openRiskChart },
                      })
                    : _vm._e(),
                  !_vm.isApprContent &&
                  _vm.isOld &&
                  _vm.disabled &&
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBL0000312", icon: "print" },
                        on: { btnClicked: _vm.print },
                      })
                    : _vm._e(),
                  !_vm.isApprContent && _vm.btnEditable && _vm.isOld
                    ? _c("c-btn", {
                        attrs: { label: "삭제", icon: "remove" },
                        on: { btnClicked: _vm.removePlan },
                      })
                    : _vm._e(),
                  _vm.btnEditable
                    ? _c("c-btn", {
                        attrs: {
                          isSubmit: _vm.isSave,
                          url: _vm.saveUrl,
                          param: _vm.assessPlan,
                          mappingType: _vm.mappingType,
                          label: "저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveAssessPlan,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    label: "평가명",
                    name: "assessmentName",
                  },
                  model: {
                    value: _vm.assessPlan.assessmentName,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "assessmentName", $$v)
                    },
                    expression: "assessPlan.assessmentName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    required: "",
                    editable: _vm.editable && !_vm.isOld,
                    codeGroupCd: "JOB_CATEGORY_CD",
                    type: "edit",
                    itemText: "codeName",
                    itemValue: "code",
                    label: "대상직군",
                    name: "jobCategoryCd",
                  },
                  on: { datachange: _vm.getScenarioItems },
                  model: {
                    value: _vm.assessPlan.jobCategoryCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "jobCategoryCd", $$v)
                    },
                    expression: "assessPlan.jobCategoryCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    range: true,
                    label: "평가기간",
                    name: "period",
                  },
                  on: { datachange: _vm.periodChange },
                  model: {
                    value: _vm.assessPlan.assessmentPeriod,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "assessmentPeriod", $$v)
                    },
                    expression: "assessPlan.assessmentPeriod",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    codeGroupCd: "RAM_ASSESS_TYPE_CD",
                    type: "edit",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "ramAssessTypeCd",
                    label: "평가구분",
                  },
                  model: {
                    value: _vm.assessPlan.ramAssessTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "ramAssessTypeCd", $$v)
                    },
                    expression: "assessPlan.ramAssessTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-field", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    data: _vm.assessPlan,
                    deptValue: "assessmentManageDeptCd",
                    type: "dept_user",
                    label: "주관자",
                    name: "assessmentManageUserId",
                  },
                  model: {
                    value: _vm.assessPlan.assessmentManageUserId,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "assessmentManageUserId", $$v)
                    },
                    expression: "assessPlan.assessmentManageUserId",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: {
                    required: true,
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    type: "edit",
                    name: "plantCd",
                  },
                  model: {
                    value: _vm.assessPlan.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "plantCd", $$v)
                    },
                    expression: "assessPlan.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-dept-multi", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    parentCheckDepts: _vm.assessPlan.deptCd,
                    label: "평가부서",
                    name: "deptCd",
                  },
                  model: {
                    value: _vm.assessPlan.deptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "deptCd", $$v)
                    },
                    expression: "assessPlan.deptCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-textarea", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    label: "상세내용",
                    name: "remark",
                  },
                  model: {
                    value: _vm.assessPlan.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "remark", $$v)
                    },
                    expression: "assessPlan.remark",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("c-upload", {
              staticClass: "q-pt-md",
              attrs: {
                attachInfo: _vm.attachInfo,
                editable: _vm.editable && !_vm.disabled,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("c-table", {
              attrs: {
                title: "위험수준 판단기준",
                tableId: "riskOfficeLevelGuide",
                columns: _vm.guideGrid.columns,
                data: _vm.guideGrid.data,
                gridHeight: "200px",
                filtering: false,
                columnSetting: false,
                usePaging: false,
                isExcelDown: false,
                isFullScreen: false,
                hideBottom: true,
              },
            }),
          ],
          1
        ),
      ]),
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "시나리오 목록",
          tableId: "riskOfficeScenario",
          merge: _vm.grid.merge,
          columns: _vm.grid.columns,
          data: _vm.assessPlan.scenarios,
          gridHeightAuto: true,
          columnSetting: false,
          usePaging: false,
          editable: _vm.editable && !_vm.disabled,
        },
        scopedSlots: _vm._u([
          {
            key: "table-chip",
            fn: function () {
              return [
                !_vm.isOld && _vm.assessPlan.scenarios.length === 0
                  ? _c(
                      "span",
                      {
                        staticClass: "q-ml-md text-blue",
                        staticStyle: { "font-size": "0.92em" },
                      },
                      [
                        _vm._v(
                          "✔️ 대상직군을 지정해야 해당 평가항목이 표시됩니다."
                        ),
                      ]
                    )
                  : _vm._e(),
                !_vm.isOld
                  ? _c(
                      "span",
                      {
                        staticClass: "q-ml-md text-blue",
                        staticStyle: { "font-size": "0.92em" },
                      },
                      [_vm._v("✔️ 개선은 평가 저장 후 등록 가능합니다.")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "customArea",
            fn: function ({ props, col }) {
              return [
                col.name === "customCol"
                  ? [
                      _c(_vm.imprComponent, {
                        tag: "component",
                        attrs: {
                          col: col,
                          props: props,
                          inputEditable:
                            _vm.editable &&
                            !_vm.disabled &&
                            Boolean(props.row.riskOfficeResultId),
                          isImmShow: true,
                          requestContentsCols: [
                            "categoryFst",
                            "categorySnd",
                            "categoryTrd",
                            "riskLevelName",
                            "riskBookFlag",
                            "assessUserName",
                          ],
                          tableKey: "riskOfficeResultId",
                          ibmTaskTypeCd: "ITT0000025",
                          ibmTaskUnderTypeCd: "ITTU000040",
                        },
                        on: { imprChange: _vm.imprChange },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm.isOld
        ? _c(
            "c-table",
            {
              ref: "docTable",
              attrs: {
                title: "관련자료",
                tableId: "riskOfficeRelatedDocument",
                gridHeight: "300px",
                columns: _vm.docGrid.columns,
                data: _vm.assessPlan.relatedDocuments,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable && !_vm.disabled,
                selection: "multiple",
                rowKey: "ramRelatedDocumentId",
              },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  !_vm.isApprContent
                    ? _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.btnEditable
                            ? _c("c-btn", {
                                attrs: { label: "직접추가", icon: "add" },
                                on: { btnClicked: _vm.addEtc },
                              })
                            : _vm._e(),
                          _vm.btnEditable
                            ? _c("c-btn", {
                                attrs: { label: "LBLADD", icon: "add" },
                                on: { btnClicked: _vm.addRelateDocument },
                              })
                            : _vm._e(),
                          _vm.btnEditable
                            ? _c("c-btn", {
                                attrs: {
                                  disabled:
                                    !_vm.assessPlan.relatedDocuments ||
                                    _vm.assessPlan.relatedDocuments.length ===
                                      0,
                                  label: "LBLREMOVE",
                                  icon: "remove",
                                },
                                on: { btnClicked: _vm.deleteRelateDocument },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _c(
        "q-dialog",
        {
          attrs: { persistent: "" },
          model: {
            value: _vm.isRiskChartOpen,
            callback: function ($$v) {
              _vm.isRiskChartOpen = $$v
            },
            expression: "isRiskChartOpen",
          },
        },
        [
          _c(
            "q-card",
            {
              staticClass: "menu-card",
              staticStyle: { width: "600px", "max-width": "90vw" },
            },
            [
              _c(
                "q-card-section",
                {
                  staticClass:
                    "row items-center q-pb-none px-2 py-1 bg-grey-8 text-white",
                },
                [
                  _c("div", [_vm._v("위험수준별 시나리오 현황 (%)")]),
                  _c("q-space"),
                  _c("q-btn", {
                    directives: [
                      { name: "close-popup", rawName: "v-close-popup" },
                    ],
                    attrs: { icon: "close", flat: "", round: "", dense: "" },
                  }),
                ],
                1
              ),
              _c("q-separator"),
              _c(
                "q-card-section",
                { staticClass: "p-2" },
                [
                  _c("apexchart", {
                    ref: "riskChart",
                    attrs: {
                      height: "400",
                      width: _vm.riskChart.chartWidth,
                      options: _vm.riskChart.chartOptions,
                      series: _vm.riskChart.series,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }